import { render } from "./RuleDetails.vue?vue&type=template&id=1a412b00&scoped=true"
import script from "./RuleDetails.vue?vue&type=script&lang=js"
export * from "./RuleDetails.vue?vue&type=script&lang=js"

import "./RuleDetails.vue?vue&type=style&index=0&id=1a412b00&lang=scss&scoped=true"

import exportComponent from "/lab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a412b00"]])

export default __exports__